import React from 'react';
import { connect } from 'react-redux';
import dismissModal from './actions/dismiss';

function ModalController({ modals = [], dismiss }) {
  const activeModal = modals.length === 0 ? null : modals[0];

  const modal = activeModal
    ? React.cloneElement(activeModal, {
        onDismiss: value => {
          dismiss(activeModal.key);
          if (typeof activeModal.props.onDismiss === 'function') {
            activeModal.props.onDismiss(value);
          }
        },
      })
    : null;

  return modal;
}

export default connect(
  state => ({
    modals: state.modal.modals,
  }),

  () => ({
    dismiss: dismissModal,
  })
)(ModalController);
